import type { InterfaceEntity, NavigationResolution } from '@unifyapps/defs/types/interface';
import { InterfaceNavigationHelper } from '../../helpers/InterfaceNavigationHelper';

export const checkIfNavigationEmpty = ({
  resolution,
  interfaceRecord,
}: {
  interfaceRecord?: InterfaceEntity;
  resolution: NavigationResolution;
}) => {
  if (!interfaceRecord) {
    return true;
  }

  return (
    !InterfaceNavigationHelper.getPrimaryNavigationByResolution(interfaceRecord, resolution)
      .length &&
    !InterfaceNavigationHelper.getSecondaryItemsByResolution(interfaceRecord, resolution)?.length
  );
};
